var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28215 4.60105C6.72671 4.304 7.1935 4.04636 7.67716 3.82976C9.04903 3.21539 9.73497 2.9082 10.6475 3.4994C11.5601 4.09061 11.5601 5.06041 11.5601 7.00001V8.50001C11.5601 10.3856 11.5601 11.3284 12.1458 11.9142C12.7316 12.5 13.6744 12.5 15.5601 12.5H17.0601C18.9997 12.5 19.9695 12.5 20.5607 13.4125C21.1519 14.3251 20.8447 15.011 20.2303 16.3829C20.0137 16.8666 19.7561 17.3334 19.459 17.7779C18.4151 19.3402 16.9315 20.5578 15.1956 21.2769C13.4597 21.9959 11.5495 22.184 9.70671 21.8175C7.86389 21.4509 6.17115 20.5461 4.84255 19.2175C3.51395 17.8889 2.60916 16.1962 2.2426 14.3534C1.87604 12.5105 2.06417 10.6004 2.78321 8.86451C3.50224 7.12861 4.71988 5.64492 6.28215 4.60105Z",
    stroke: "#DADCDE",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5061 7.06901C20.6943 5.00831 19.0518 3.36579 16.9911 2.55398C15.4495 1.94669 14.0601 3.34316 14.0601 5.00002V9.00002C14.0601 9.5523 14.5078 10 15.0601 10H19.0601C20.7169 10 22.1134 8.61055 21.5061 7.06901Z",
    stroke: "#DADCDE",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.98bd19e0172c25c8129b215591202a3a.svg";
export { ForwardRef as ReactComponent };